document.querySelectorAll('.faq-tabs').forEach(section => {
  const openFirst = section.dataset.openFirst === 'true';
  const tabs = Array.from(section.querySelectorAll('.faq-tabs__tab'));
  const panels = Array.from(section.querySelectorAll('.faq-tabs__panel'));

  const getItems = panel => Array.from(panel.querySelectorAll('.faq-tabs__item'));

  const setItemState = (item, shouldOpen, immediate = false) => {
    const button = item.querySelector('.faq-tabs__question');
    const answerWrapper = item.querySelector('.faq-tabs__answer-wrapper');
    const answer = item.querySelector('.faq-tabs__answer');

    if (shouldOpen) {
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      if (immediate) {
        answerWrapper.style.height = 'auto';
        return;
      }
      const targetHeight = answer.offsetHeight;
      answerWrapper.style.height = '0px';
      requestAnimationFrame(() => {
        answerWrapper.style.height = targetHeight + 'px';
      });
      return;
    }

    item.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    const currentHeight = answer.offsetHeight;
    answerWrapper.style.height = currentHeight + 'px';
    if (immediate) {
      answerWrapper.style.height = '0px';
      return;
    }
    requestAnimationFrame(() => {
      answerWrapper.style.height = '0px';
    });
  };

  const collapseAll = panel => {
    getItems(panel).forEach(item => setItemState(item, false, true));
  };

  const openFirstItem = panel => {
    if (!openFirst) return;
    const items = getItems(panel);
    if (!items.length) return;
    items.forEach(item => setItemState(item, false, true));
    setItemState(items[0], true, true);
  };

  const activateTab = tabId => {
    tabs.forEach(tab => {
      const isActive = tab.dataset.tab === tabId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(panel => {
      const isActive = panel.dataset.tabPanel === tabId;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
        openFirstItem(panel);
      } else {
        panel.setAttribute('hidden', '');
        collapseAll(panel);
      }
    });
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      activateTab(tab.dataset.tab);
    });
  });

  panels.forEach(panel => {
    getItems(panel).forEach(item => {
      const button = item.querySelector('.faq-tabs__question');
      const answerWrapper = item.querySelector('.faq-tabs__answer-wrapper');

      button.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        setItemState(item, !isOpen);
      });

      answerWrapper.addEventListener('transitionend', () => {
        if (item.classList.contains('is-open')) {
          answerWrapper.style.height = 'auto';
        }
      });
    });
  });

  let initialTab = tabs.find(tab => tab.classList.contains('is-active')) || tabs[0];
  
  const urlParamKey = section.dataset.urlParamKey || 'faq';
  const urlParams = new URLSearchParams(window.location.search);
  const faqParam = urlParams.get(urlParamKey);
  let shouldScroll = false;

  if (faqParam) {
    const tabFromUrl = tabs.find(tab => tab.dataset.tabHandle === faqParam.toLowerCase());
    if (tabFromUrl) {
      initialTab = tabFromUrl;
      shouldScroll = true;
    }
  }

  if (initialTab) {
    activateTab(initialTab.dataset.tab);
  }

  if (shouldScroll) {
    setTimeout(() => {
      const tabsContainer = section.querySelector('.faq-tabs__tabs');
      if (tabsContainer && initialTab) {
        const scrollLeft = initialTab.offsetLeft - (tabsContainer.clientWidth / 2) + (initialTab.clientWidth / 2);
        tabsContainer.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }

      const activePanel = section.querySelector('.faq-tabs__panel.is-active');
      const targetElement = activePanel || section;
      const headerOffset = document.querySelector('sticky-header') ? document.querySelector('sticky-header').offsetHeight : 0;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }, 300);
  }
});
